module.exports = __webpack_public_path__ + "static/dp-princip-3-b388a939582e009c2e439064c7c7aed9.svg";